module.exports = __webpack_public_path__ + "static/img/default_img_nointernet.a0a9ae69.png";